export type PlatinumTokens = {
	normal: string;
};

export default {
	normal: '{named.platinum}',
} satisfies PlatinumTokens;
